import toast from 'react-hot-toast';

export const TOAST_WITH_LINK_DURATION_MS = 8000;

type ToastSuccessWithLinkOptions = {
  message: string;
  linkLabel: string;
  path: string;
  navigate: (path: string) => unknown;
  testId?: string;
};

/**
 * Success toast with an in-app link. The `Toaster` sits outside the router, so the
 * link navigates through the caller's `navigate`.
 *
 * @example
 *   toastSuccessWithLink({ message, linkLabel, path: `/rfq/view/${id}`, navigate });
 */
export function toastSuccessWithLink({
  message,
  linkLabel,
  path,
  navigate,
  testId,
}: ToastSuccessWithLinkOptions) {
  toast.success(
    (shownToast) => (
      <span>
        {message}{' '}
        <a
          href={path}
          className="font-medium text-prim underline"
          data-testid={testId}
          onClick={(event) => {
            event.preventDefault();
            toast.dismiss(shownToast.id);
            void navigate(path);
          }}
        >
          {linkLabel}
        </a>
      </span>
    ),
    { duration: TOAST_WITH_LINK_DURATION_MS }
  );
}
